import React from 'react';
// import AppImage from '../AppImage';
import Loader from '../Loader';
import styles from './styles.module.scss';
import { AdminContext } from '../../context/AdminContext';
import { useContext } from 'react';

const AppFormBox = ({
  className = '',
  title,
  error,
  showError = true,
  showProfileError = false,
  showTitle = true,

  prefixClass = styles.prefix,
  prefix,
  wraperClassName = '',
  inputTitleClass,
  errorProfile,
  wrapperStyle = styles.wrapper,
  loading = false,
  showDescription = false,
  children,
  affix,

  prefix0,
  onClick,
}) => {
  const { themeMode } = useContext(AdminContext);
  return (
    <div className={`${styles.container}${` `}${className} `}>
      <div className={`flex flex-row justify-between items-center w-full`}>
        {showTitle && (
          <p className={inputTitleClass ? inputTitleClass : styles.inputTitle}>
            {title}
          </p>
        )}
        {showDescription && <div>{children}</div>}
        {showProfileError && loading && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              در حال بررسی نام
            </p>

            <Loader
              className={styles.lds_ring}
              width={'w-20px'}
              height={'h-20px'}
            />
          </div>
        )}
        {showProfileError && !loading && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              {errorProfile}
            </p>

            <img
              width={20}
              height={20}
              src='/imgs/profile/warning.svg'
              alt='error'
            />
          </div>
        )}
      </div>
      <div
        className={`${wrapperStyle} selectButton ${wraperClassName} ${
          showError == true && styles.yellowBorder
        } ${showProfileError == true && styles.redBorder}`}
      >
        {prefix0 && (
          <div
            className={`${styles.prefix0}  ${
              themeMode == "dark"  && 'makeWhite'
            }`}
            onClick={onClick}
          >
            {prefix0}
          </div>
        )}

        {prefix && (
          <div
            className={`${prefixClass} ${themeMode == "dark"  && 'makeWhite'}`}
          >
            {prefix}
          </div>
        )}
        {affix && (
          <div
            className={`${styles.affix} ${
              themeMode == "dark"  && 'makeWhite'
            }`}
          >
            {affix}
          </div>
        )}
      </div>
      {showError == true && (
        <p className={`${styles.inputError} preserveWhiteThemeColor`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default AppFormBox;
